
import { Component, Vue } from 'vue-property-decorator'
import TheAccountMenu from '@/core/components/TheAccountMenu.vue'
import TheNotificationMenu from '@/modules/in-app-notification/views/TheNotificationMenu.vue'

@Component({
  name: 'TheHeader',
  components: { TheAccountMenu, TheNotificationMenu }
})
export default class TheHeader extends Vue {}
